import React, { ElementType, forwardRef } from "react";
import Chip, { ChipProps } from "@mui/material/Chip";

type ExtendedProps = ChipProps & {
  handleDelete?: any;
  value: string;
  component?: ElementType;
};

const CustomizedChips = forwardRef(
  (
    {
      handleDelete,
      variant,
      value,
      color,
      onClick,
      component,
      ...props
    }: ExtendedProps,
    ref
  ) => {
    return (
      <Chip
        ref={ref}
        label={value}
        variant={variant || "outlined"}
        onDelete={handleDelete}
        size="small"
        color={color || "secondary"}
        onClick={onClick}
        component={component || "div"}
        {...props}
      />
    );
  }
);
export default CustomizedChips;
